import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

// LocaNest's OWN Google OAuth client — goes straight to Google's account picker (accounts.google.com).
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleSignIn({ clientId, role, referralCode } = {}) {
  if (!clientId) { toast.error("Google sign-in is not configured yet. Please use email & password."); return; }
  const state = Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem("ln_google_state", state);
  if (role) sessionStorage.setItem("ln_google_role", role); else sessionStorage.removeItem("ln_google_role");
  if (referralCode) sessionStorage.setItem("ln_google_ref", referralCode); else sessionStorage.removeItem("ln_google_ref");
  const redirectUri = window.location.origin + "/auth/google";
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid email profile",
    state,
    prompt: "select_account",
    access_type: "online",
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}

export default function GoogleSignInButton({ role, referralCode, label = "Continue with Google", testId = "google-signin-btn" }) {
  const [clientId, setClientId] = useState(null);
  useEffect(() => { api.get("/config").then(({ data }) => setClientId(data?.google_client_id || "")).catch(() => setClientId("")); }, []);
  if (clientId === "") return null;
  return (
    <button
      type="button"
      onClick={() => startGoogleSignIn({ clientId, role, referralCode })}
      disabled={clientId === null}
      className="w-full h-11 rounded-md border border-[#1A1F2C]/15 bg-white hover:bg-[#F0EBE1] text-sm font-medium flex items-center justify-center gap-3 transition-colors disabled:opacity-60"
      data-testid={testId}
    >
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.5 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.6 17.7 9.5 24 9.5z" />
        <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z" />
        <path fill="#FBBC05" d="M10.5 28.7A14.6 14.6 0 0 1 9.5 24c0-1.6.3-3.2.8-4.7l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.8l7.9-6.1z" />
        <path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.7l-7.5-5.8c-2.1 1.4-4.8 2.3-8.1 2.3-6.3 0-11.6-4.1-13.5-9.8l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
      </svg>
      {label}
    </button>
  );
}
